var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#ff6633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2005_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4576 32.7666C26.0913 32.7666 28.2263 30.6293 28.2263 27.9929C28.2263 25.3565 26.0913 23.2192 23.4576 23.2192C20.824 23.2192 18.689 25.3565 18.689 27.9929C18.689 30.6293 20.824 32.7666 23.4576 32.7666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6403 21.1563C42.5 20.9943 42.3328 20.8647 42.1332 20.7729C41.4265 20.4435 40.5203 20.7081 40.051 21.4371C40.0402 21.4533 40.0186 21.4587 40.0024 21.4587C33.3295 19.6605 26.6566 17.8676 19.9783 16.0694C19.4443 15.929 18.8671 15.9992 18.4086 16.3016C17.8961 16.6418 17.5239 17.1386 17.3944 17.711C17.2272 18.4401 17.4484 19.2555 17.9339 19.7469C18.0849 19.8981 18.4086 20.2221 18.7808 20.1357C19.099 20.0655 19.2663 19.7361 19.304 19.6551C19.5468 18.7533 19.7949 17.8406 20.0431 16.9334C26.6189 18.6723 33.2001 20.4111 39.7758 22.1499C39.2472 23.3001 38.7185 24.4503 38.1845 25.6006C38.1575 25.606 38.1252 25.6168 38.0928 25.6276C37.9579 25.6762 37.8662 25.741 37.8554 25.7518C37.7422 25.8328 31.7274 29.5696 23.3714 34.7645C23.1664 34.9265 22.627 35.4071 22.4166 36.2225C22.2925 36.7139 22.3303 37.1297 22.3789 37.3835C23.6465 41.844 24.9142 46.2991 26.1765 50.7595L16.3425 66.3549C15.6898 67.3918 15.9973 68.7688 17.033 69.4222C17.3998 69.6544 17.8098 69.7678 18.2144 69.7678C18.9534 69.7678 19.6709 69.4006 20.097 68.731L30.3788 52.4173L30.4004 67.7806C30.4004 69.0064 31.3983 70 32.6229 70C32.6229 70 32.6229 70 32.6282 70C33.8528 70 34.8507 69.001 34.8454 67.7752C34.8346 61.2411 34.8292 54.7124 34.8184 48.1783C34.1764 45.057 33.8366 43.3776 33.1947 40.2564C33.1893 40.2456 33.1947 40.2294 33.2054 40.2186C34.6997 38.3015 36.1994 36.3899 37.6936 34.4783C37.7637 34.3865 37.8231 34.2893 37.8716 34.1813C39.5331 30.4012 41.1946 26.6158 42.8561 22.8357C43.0988 22.2741 43.0395 21.6099 42.6403 21.1563ZM35.2068 32.3615C34.2466 32.8421 33.2864 33.3281 32.3262 33.8087C32.3262 33.4847 32.3262 33.1553 32.3262 32.8313C33.5399 32.0861 34.7536 31.3462 35.9674 30.601C35.7139 31.1896 35.4603 31.7728 35.2068 32.3615Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2005_1698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolferIcon);
export default __webpack_public_path__ + "static/media/golfer-icon.4b4b3c6f7f2ef7a963a2417d633e4026.svg";
export { ForwardRef as ReactComponent };